import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFound() {
  return (
    <>
      <Header />
      <main className="pt-32 pb-24 bg-spin-sand min-h-[70vh] flex items-center">
        <div className="max-w-2xl mx-auto px-5 text-center">
          <p className="text-[128px] md:text-[180px] font-heading font-extrabold text-spin-green leading-none tracking-tight">
            404
          </p>
          <hr className="section-divider" />
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-spin-dark mb-4">
            Uups – diese Seite gibt es nicht.
          </h1>
          <p className="text-spin-grey leading-relaxed mb-8 max-w-md mx-auto">
            Die von dir angeforderte Seite konnte leider nicht gefunden werden. Vielleicht wurde
            sie verschoben oder du hast dich vertippt.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-spin-green text-white font-semibold rounded-md hover:bg-spin-green-dark transition-colors"
            >
              <Home size={16} /> Zur Startseite
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 px-6 py-3 border-2 border-spin-green text-spin-green font-semibold rounded-md hover:bg-spin-green hover:text-white transition-colors"
            >
              <ArrowLeft size={16} /> Zurück
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
